export default __webpack_public_path__ + "static/co-production-collective-98e1bbfa8cb0db2da7d6114bdfb1e0cf.png";